function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawBirthdayCake = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1196.94 837.07",
    style: style
  }, props), React.createElement("path", {
    d: "M663.83 91.84c-46.25 32.39-106.24 30.29-158.81 13.44S404.16 58.44 352.94 37.12A493.86 493.86 0 0 0 219.32 2.28c-65.28-7.47-138.18 1.63-183.66 54-50.65 58.3-46.76 163.45 8 217 27.87 27.22 64.36 40.58 96.18 61.84s61.28 56.54 58.57 97.57c-2.51 38-31.68 67.12-61.87 85.4-23.33 14.13-52.06 29.57-54.87 58.84-2.72 28.32 21.44 50.51 44.51 63.13 75.26 41.17 168 40.77 243-1 26.76-14.99 51.32-34.85 79.37-46.47 73.65-30.53 154.81.2 232.8 11.44a465.38 465.38 0 0 0 198-14.42c38.62-11.4 77.39-28.84 104.52-61.33 19.57-23.43 31.76-53.08 43.2-82.36q18.3-46.85 35.19-94.33c6.75-19 13.4-38.39 15.15-58.72 3.16-36.86-10.16-73.29-28.3-104.39-43.07-73.84-115.61-125.77-194.17-138.96s-161.67 12.55-222.6 68.95",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M908.14 538.07l-2.78-1.61c2.6-4.51-4.39-23.69-10.17-33.35a59.34 59.34 0 0 1-7.68-18.62c-1.85-9.28-.09-17.33 5.23-23.92 11.05-13.68 11-39.78 11-40h3.22c0 1.11.12 27.51-11.66 42.09-7.83 9.69-6.92 22.77 2.71 38.87 4.48 7.54 14.17 29.54 10.13 36.54z",
    fill: "#d4d5e0"
  }), React.createElement("path", {
    d: "M943.42 392.73c.73-26.15-16.47-47.85-38.42-48.46s-40.33 20.09-41.06 46.24c-.71 25.39 15.48 46.58 36.52 48.36a14 14 0 0 1-3.26 7.15c-3.19 3.25 10 .28 10 .28a23.75 23.75 0 0 1-1.42-7.41c20.41-1.51 36.95-21.39 37.64-46.16z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M875.51 410.19c-3.25-9.95-.25-19.94 6.69-22.95-.32.08-.64.16-1 .27-7.6 2.48-11 12.91-7.62 23.3 3.29 10.08 11.79 16.41 19.23 14.5.2.76-14.01-5.05-17.3-15.12z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M924.64 574.29l3.22.13c.22-5.2 16.41-17.63 26.47-22.68a59.13 59.13 0 0 0 16.47-11.59c6.55-6.84 9.39-14.58 8.43-23-2-17.46 12.11-39.44 12.25-39.66l-2.7-1.75c-.61.94-14.86 23.15-12.75 41.78 1.41 12.38-6.38 22.92-23.15 31.34-7.94 3.97-27.94 17.36-28.24 25.43z",
    fill: "#d4d5e0"
  }), React.createElement("path", {
    d: "M972.87 432.74c13.42-22.46 39.58-31.54 58.42-20.28s23.25 38.6 9.83 61.06c-13 21.8-38.07 31-56.76 21.2a13.87 13.87 0 0 0-1.09 7.78c.94 4.46-8.61-5.14-8.61-5.14a23.43 23.43 0 0 0 5.18-5.49c-16.4-12.21-19.68-37.86-6.97-59.13z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1020.79 483.91c8.09-6.65 10.92-16.69 6.67-23a7.85 7.85 0 0 1 .67.74c5.08 6.17 2.36 16.8-6.08 23.74-8.19 6.74-18.75 7.53-24 1.92-.56.64 14.57 3.33 22.74-3.4z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M352.7 704.07l-3.22.13c-.21-5.2-16.41-17.63-26.46-22.68-7-3.5-12.37-7.29-16.48-11.59-6.55-6.84-9.38-14.57-8.43-23 2-17.47-12.1-39.45-12.25-39.67l2.7-1.75c.61.94 14.87 23.16 12.75 41.78-1.4 12.38 6.39 22.92 23.15 31.35 7.9 3.98 27.9 17.37 28.24 25.43z",
    fill: "#d4d5e0"
  }), React.createElement("path", {
    d: "M304.47 562.53c-13.42-22.46-39.53-31.54-58.42-20.28s-23.25 38.6-9.83 61.06c13 21.81 38.07 31 56.76 21.2a13.9 13.9 0 0 1 1.09 7.79c-.94 4.45 8.61-5.15 8.61-5.15a23.57 23.57 0 0 1-5.17-5.48c16.43-12.22 19.67-37.87 6.96-59.14z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M256.55 613.7c-8.09-6.65-10.92-16.69-6.67-23-.23.24-.46.48-.67.74-5.08 6.17-2.36 16.8 6.08 23.75 8.19 6.74 18.75 7.52 24 1.91.56.64-14.56 3.33-22.74-3.4z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M865.63 698.32l-2-2.48c4-3.31 4.21-23.72 2.2-34.79-1.39-7.68-1.61-14.27-.65-20.14 1.53-9.34 6-16.26 13.31-20.56 15.15-8.92 24.23-33.39 24.32-33.64l3 1.11c-.38 1-9.56 25.79-25.71 35.31-10.73 6.32-14.47 18.88-11.12 37.34 1.56 8.7 2.89 32.73-3.35 37.85z",
    fill: "#d4d5e0"
  }), React.createElement("path", {
    d: "M949.72 574.66c9.87-24.23 1.39-50.58-18.94-58.87s-44.82 4.64-54.69 28.87c-9.59 23.52-1.87 49 17.19 58.1a13.85 13.85 0 0 1-5.56 5.55c-4.13 1.93 9.29 3.79 9.29 3.79a23.65 23.65 0 0 1 1.27-7.44c19.66 5.76 42.09-7.05 51.44-30z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M880.01 567.15c.45-10.46 6.77-18.76 14.32-19.13-.32 0-.65-.08-1-.09-8-.35-14.84 8.22-15.31 19.14-.46 10.59 5.26 19.51 12.91 20.33-.13.8-11.38-9.67-10.92-20.25z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 605.48,
    cy: 706.71,
    rx: 302.44,
    ry: 22.48,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#53425a",
    d: "M580.01 121.17v35.33h3.7v-37.04l-3.7 1.71zM655.79 130.57v32.76h5.13l-1.14-36.47-3.99 3.71zM509.92 136.84l-3.42 3.7v31.91h3.42v-35.61z"
  }), React.createElement("path", {
    d: "M524.17 230.85h-22.23v-63.78h17.1a8.64 8.64 0 0 0-.39 1.51c-.67 3.67-.46 10.59.16 18.51 1.49 18.98 5.36 43.76 5.36 43.76zM601.67 230.85l-27.93 3.42v-83.2h17.67c-.12.94-.2 2-.24 3.2a141.06 141.06 0 0 0 1.1 18.78c.6 5.42 1.39 11.24 2.25 17 .67 4.49 1.39 9 2.1 13.2 2.56 15.27 5.05 27.6 5.05 27.6zM676.88 222.31l-27.35 2.28v-66.67h18.81c-.67 1.42-1 3.81-1 6.86a122.35 122.35 0 0 0 1.47 16.42c2.7 18.67 8.07 41.11 8.07 41.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M514.48 72.16s1.71 6.84-16.24 25.64-10.82 56.7 8.26 55.56c0 0 17.85 3 24.27-9.2a16.26 16.26 0 0 0-1.14-16.67c-5.9-8.69-17.28-26.95-15.15-35.67z",
    fill: "#ffc13d"
  }), React.createElement("path", {
    d: "M510.87 98s1.07 4.28-10.14 16-6.79 35.43 5.21 34.72c0 0 11.4 1.88 15.29-6a10.2 10.2 0 0 0-.86-10.18c-3.48-5.13-10-15.56-9.59-21.29.06-.9.14-1.79.14-2.69z",
    fill: "#fff",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M662.62 63.59s1.71 6.83-16.24 25.64-10.83 56.7 8.26 55.56c0 0 17.85 2.94 24.27-9.21a16.29 16.29 0 0 0-1.14-16.67c-5.9-8.69-17.28-26.94-15.15-35.66z",
    fill: "#ffc13d"
  }), React.createElement("path", {
    d: "M660.35 104.34s.8 3.2-7.6 12-5.06 26.54 3.87 26c0 0 8.35 1.37 11.36-4.31a7.63 7.63 0 0 0-.54-7.8c-2.76-4.07-8.08-12.61-7.09-16.7z",
    fill: "#fff",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M587.04 38.86s2.08 8.31-19.75 31.18-13.16 68.94 10 67.56c0 0 21.7 3.58 29.51-11.2a19.8 19.8 0 0 0-1.39-20.27c-7.17-10.56-21-32.76-18.42-43.37z",
    fill: "#ffc13d"
  }), React.createElement("path", {
    d: "M584.75 80.13s1.16 4.64-11 17.39-7.34 38.47 5.61 37.7c0 0 12.11 2 16.46-6.25a11 11 0 0 0-.77-11.31c-4-5.89-11.72-18.28-10.28-24.19zM518.81 187.07c-5.22 5.49-12.44 15.33-16.86 21.56v-22.56c4.88-5.88 11.87-12.87 16.7-17.53-.71 3.68-.46 10.6.16 18.53zM592.27 173.07a202 202 0 0 0-18.53 16.85v-21.56a99.55 99.55 0 0 1 17.43-14.08 141.06 141.06 0 0 0 1.1 18.79z",
    fill: "#fff",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M596.62 203.28c-6.87 6-16.31 14.57-22.88 20.54v-15.43c6.86-6.32 15.2-13.57 20.78-18.32.67 4.5 1.42 9 2.1 13.21z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M668.84 181.2c-6.59 5.52-14.23 13.11-19.31 18.33v-21.46c5.4-5.36 12.55-10.11 17.84-13.25a122.35 122.35 0 0 0 1.47 16.38z",
    fill: "#fff",
    opacity: 0.5
  }), React.createElement("path", {
    fill: "#c99398",
    d: "M453.79 246.24h278.92v127.65H453.79z"
  }), React.createElement("path", {
    d: "M732.72 246.24v19.21c-5.33 1-12.32-.56-18.18-2.52a24.14 24.14 0 0 0-20.9 2.64c-16.07 10.5-28.62 8.28-37.37 3.06a32.18 32.18 0 0 0-29.13-2.25 31.88 31.88 0 0 1-12.92 2.37 27.16 27.16 0 0 0-14.66 4c-13.19 8-26.35 3.37-34.61-1.46a24.37 24.37 0 0 0-17.9-2.58 26 26 0 0 1-8 .64 29.92 29.92 0 0 0-17.56 3.79c-21.78 12.73-29-2.73-33.27-5-4.85-2.56-5.41 6.27-6.84 6.27s-6.26-11.68-7.41-7.7c-.53 1.88-5 4.12-9.63 6a19.29 19.29 0 0 1-10.59 1.09v-27.56z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M464.94 220.79s-45.71 20.4-21.32 45.89a19 19 0 0 0 20.8 4.35c4.61-1.86 9.1-4.11 9.63-6 1.14-4 6 7.69 7.41 7.69s2-8.83 6.84-6.27c4.29 2.27 11.49 17.73 33.27 5a29.85 29.85 0 0 1 17.57-3.78 25.46 25.46 0 0 0 7.94-.66 24.46 24.46 0 0 1 17.9 2.58c8.26 4.83 21.42 9.46 34.61 1.47a27.27 27.27 0 0 1 14.64-3.99 31.36 31.36 0 0 0 12.91-2.37 32.24 32.24 0 0 1 29.13 2.25c8.75 5.23 21.3 7.45 37.37-3a24.13 24.13 0 0 1 20.9-2.64c11.68 3.91 27.92 6.41 26.45-10.7-2.28-26.5-33.62-34.19-46.73-34.48s-34.76-2.56-59.26 0-74.36 2.28-74.36 2.28-83.7-3.41-95.7 2.38z",
    fill: "#f8f8fa"
  }), React.createElement("path", {
    d: "M732.72 289.2v33.48a33.22 33.22 0 0 1-4.26-.39c-6.62-1-13.23-3.14-19.86-2.23-10.49 1.45-18.57 10.2-28.79 12.94-20.45 5.5-39.85-14.24-61-13.68-15.22.4-27.94 11.07-41.94 17a71 71 0 0 1-45.13 3.41c-12.74-3.28-24.27-10-36.36-15.23s-25.59-8.89-38.34-5.63c-1.08.27-2.14.6-3.22.9v-23.28a28 28 0 0 0 4.63.31c5-.24 9.16-1.38 14.28-.4a53.16 53.16 0 0 1 13.45 4.67c9.22 4.5 17.75 10.6 27.59 13.51 7.36 2.19 15.13 2.49 22.81 2.33 15.14-.33 30.69-2.57 43.71-10.29 8.31-4.94 15.74-12.13 25.26-13.79 19.64-3.41 35.85 18 55.79 18.63 5 .18 9.88-1 14.72-2.12 7.46-1.76 15.11-3.6 21.44-7.9 6.67-4.53 11.87-11.76 19.7-13.69 3.87-.95 8-.47 11.83.43 1.24.29 2.48.63 3.69 1.02z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M732.72 285.78v33.48a35.12 35.12 0 0 1-4.26-.38c-6.62-1-13.23-3.15-19.86-2.24-10.49 1.45-18.57 10.2-28.79 12.94-20.45 5.5-39.85-14.24-61-13.68-15.22.4-27.94 11.07-41.94 17a71.11 71.11 0 0 1-45.13 3.42c-12.8-3.25-24.29-10-36.38-15.25s-25.59-8.89-38.34-5.63c-1.08.28-2.14.6-3.22.9v-23.27a27 27 0 0 0 4.63.31c5-.24 9.16-1.38 14.28-.4a54 54 0 0 1 13.47 4.68c9.22 4.51 17.75 10.6 27.59 13.51 7.36 2.19 15.13 2.49 22.81 2.33 15.14-.33 30.69-2.57 43.71-10.29 8.31-4.93 15.74-12.13 25.26-13.79 19.64-3.41 35.85 17.95 55.79 18.63 5 .18 9.88-1 14.72-2.12 7.46-1.76 15.11-3.59 21.44-7.9 6.67-4.53 11.87-11.75 19.7-13.69 3.87-.95 8-.47 11.83.43 1.24.3 2.48.63 3.69 1.01z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M438.49 302.16c-3.2 6.62 1.16 16 8.47 16.83 3.41.37 6.74-.95 10.06-1.8 12.75-3.26 26.26.44 38.34 5.64s23.58 11.95 36.36 15.24a71.07 71.07 0 0 0 45.12-3.41c14-6 26.73-16.63 42-17 21.17-.55 40.57 19.18 61 13.68 10.22-2.74 18.31-11.49 28.79-12.93 6.63-.92 13.24 1.25 19.86 2.23s14.24.42 18.68-4.6c4.61-5.22 3.84-13.73-.34-19.31s-11-8.62-17.77-10.2c-3.88-.89-8-1.38-11.83-.43-7.83 1.94-13 9.15-19.7 13.69-6.34 4.3-14 6.14-21.44 7.9-4.84 1.15-9.75 2.3-14.73 2.13-19.93-.69-36.14-22.05-55.79-18.64-9.52 1.66-16.94 8.86-25.25 13.79-13 7.72-28.58 10-43.71 10.29-7.68.16-15.46-.14-22.82-2.32-9.83-2.92-18.36-9-27.57-13.52a54.25 54.25 0 0 0-13.47-4.69c-5.13-1-9.28.17-14.29.41-3.81.18-7.07-1.21-11-.08a14.07 14.07 0 0 0-8.97 7.1z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#c99398",
    d: "M396.81 373.89h397.88v156.27H396.81z"
  }), React.createElement("path", {
    d: "M732.72 347.23v26.66h-155.1c-.27 0-.53-.06-.8-.08a20.69 20.69 0 0 0-3.94.08H453.8v-23.77c13 1.58 26.06 3.59 39 3.53 17.12-.07 34-3.63 51.19-2.67 60 3.33 121 4.32 180.78-2.78z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M794.69 373.89v14.09c-4.32-.55-8.49-2.27-12.67-3.64-3.77-1.23-7.84-2.19-11.67-1.17-2 .54-3.86 1.6-5.85 2.21-8.32 2.6-17-2.81-25.73-2.84s-16.39 5.17-24.83 7.07c-13.06 2.93-26.4-2.21-38.9-7-5.06-1.92-10.93-3.76-15.65-1.13-2.08 1.15-3.64 3.05-5.67 4.3-5.92 3.66-13.68.8-19.58-2.89-3.74-2.33-8.26-5.08-12.2-3.11-2 1-3.31 3-5 4.56-5.33 4.78-13.73 3.5-20.27.59s-12.73-7.19-19.86-7.72c-10-.76-18.86 6-27.62 11s-20.94 7.91-28.09.8c-2.37-2.35-4.12-5.76-7.36-6.57-5.36-1.33-9.39 5.3-14.79 6.46-6.66 1.44-12.07-5.65-18.75-7-6.91-1.44-13.33 3.36-19.43 6.91s-15 5.54-19.37.05c-1.41-1.75-2.18-4.11-4.11-5.28a8.33 8.33 0 0 0-4.75-.76 48.46 48.46 0 0 0-16.76 4c-6.09 2.69-12 6.71-18.62 6.58h-.36v-19.51z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M492.75 355.36c-30.52.13-62-11.31-90.81-1.13-10.44 3.69-21 12.42-19.93 23.44a16.09 16.09 0 0 0 15.16 14c6.65.12 12.53-3.91 18.62-6.59a48.24 48.24 0 0 1 16.76-4 8.29 8.29 0 0 1 4.76.77c1.92 1.15 2.7 3.52 4.11 5.27 4.42 5.5 13.27 3.5 19.36-.05s12.53-8.36 19.43-6.91c6.67 1.39 12.09 8.48 18.75 7 5.4-1.16 9.43-7.79 14.79-6.45 3.24.8 5 4.2 7.36 6.56 7.15 7.11 19.31 4.17 28.08-.8s17.58-11.74 27.63-11c7.13.54 13.33 4.83 19.87 7.74s14.93 4.18 20.26-.59c1.69-1.52 3-3.56 5-4.57 3.94-2 8.46.78 12.2 3.11 5.9 3.69 13.66 6.55 19.58 2.89 2-1.25 3.59-3.14 5.67-4.3 4.72-2.63 10.59-.79 15.65 1.13 12.5 4.77 25.85 9.92 38.9 7 8.44-1.9 16.18-7.1 24.83-7.07s17.41 5.44 25.73 2.85c2-.62 3.83-1.68 5.84-2.22 3.84-1 7.91-.06 11.68 1.17 5 1.64 10 3.79 15.26 3.81s11-2.86 12.29-8c1-3.91-.91-8-3.26-11.25-8.51-11.91-23.28-18-37.83-19.67s-29.21.65-43.75 2.37c-59.75 7.14-120.8 6.2-180.8 2.82-17.15-.96-34.06 2.6-51.19 2.67z",
    fill: "#f8f8fa"
  }), React.createElement("path", {
    d: "M794.69 474.29v38.51c-40.63 7.31-82.18 9-123.5 10.71-26.77 1.09-53.56 2.18-80.34 1.63-20-.4-40-1.73-59.92-3l-64-4.24-60.22-4-9.9-.66V478.9a38.08 38.08 0 0 1 8-3.93 41.83 41.83 0 0 1 40.13 7.18c20.18-12.14 48.05-9.82 65.94 5.52 24.65-18.52 61.67-18.28 86.08.55 16.17-19.81 49.08-22.87 68.61-6.36 18.67-17.44 50.66-18 70-1.3 13.6-10.43 32.3-11.12 49.28-8.73a38.26 38.26 0 0 1 9.84 2.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M811.78 511.07a521.26 521.26 0 0 1-66.73 9.91c-7.49.68-15 1.23-22.52 1.72-17.09 1.1-34.24 1.8-51.34 2.5-10.87.44-21.74.88-32.62 1.22l-6.82.19c-13.64.35-27.27.5-40.9.22-20-.4-40-1.73-59.92-3l-64-4.23-60.22-4-14.78-1c-5.31-.35-9.25.79-11.4-3.95-2.55-5.68-.3-11.33 2.82-16.27.56-.88 1.14-1.73 1.73-2.56a41.34 41.34 0 0 1 19.73-15.16 41.83 41.83 0 0 1 40.13 7.2c20.18-12.14 48.05-9.82 65.94 5.52 24.65-18.52 61.67-18.28 86.08.55 16.17-19.81 49.08-22.87 68.61-6.36 18.67-17.44 50.66-18 70-1.3 13.6-10.43 32.3-11.12 49.28-8.73 5 .71 10.19 1.75 14.07 5 5.4 4.51 6.63 11.65 8.11 18.78.91 4.87 2.07 9.75 4.75 13.75z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#c99398",
    d: "M369.89 516.05h439.94v181.2H369.89z"
  }), React.createElement("path", {
    d: "M811.78 511.07a521.26 521.26 0 0 1-66.73 9.91 45.9 45.9 0 0 0-22.52 1.72 4 4 0 0 0-.41.14c-13.86 4.9-25.79 16.54-40.49 16.35-11.69-.12-21.88-7.89-33.16-11.12a42 42 0 0 0-9.9-1.61 43.18 43.18 0 0 0-6.82.19c-13.64.35-27.27.5-40.9.22-20-.4-40-1.73-59.92-3l-64-4.23-60.22-4-14.78-1c-5.31-.35-9.25.79-11.4-3.95-2.55-5.68-.3-11.33 2.82-16.27 2.69 0 5.38.24 8 .43q61 4.29 121.93 8.89l-6.25 1.1a682.58 682.58 0 0 1 128.37-7.94c20 .66 40.19 2.2 60.09-.36 14-1.79 27.69-5.59 41.74-6.78 19.3-1.63 38.64 1.7 57.74 5a116.06 116.06 0 0 1 11.97 2.54c1 4.89 2.16 9.77 4.84 13.77z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M809.83 516.07v17c-5.49-.81-10.87-1.62-14.2 2.28-1.56 1.84-2.17 4.33-3.69 6.21-3.14 3.88-9.27 3.87-13.75 1.67s-7.88-6-11.73-9.21a46.69 46.69 0 0 0-44.34-7.76c-13.86 4.9-25.79 16.53-40.49 16.35-11.74-.16-21.88-7.91-33.16-11.16a44.82 44.82 0 0 0-37.78 6.42c-8 5.67-15.52 14.46-25.24 13.34-5.09-.59-9.37-3.9-13.7-6.66a72.92 72.92 0 0 0-28.69-10.64c-4.45-.63-9.18-.82-13.28 1-5.18 2.33-8.52 7.49-13.32 10.51-11.15 7-25.62.69-37.11-5.75s-25.74-13-37.13-6.41c-2.69 1.56-5 3.78-7.82 5-16 7-31.77-20.07-48.21-14.08-3.71 1.35-6.67 4.26-10.32 5.77a12.48 12.48 0 0 1-6 .84v-14.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M513.34 505.43q-61-4.59-121.94-8.89c-7-.5-14.29-1-21.08 1s-13.12 7.08-14.57 14c-2.19 10.47 10.23 20.8 20.13 16.72 3.65-1.5 6.6-4.42 10.31-5.77 16.44-6 32.18 21.12 48.2 14.08 2.84-1.25 5.14-3.46 7.82-5 11.4-6.62 25.63 0 37.13 6.41s26 12.77 37.12 5.75c4.81-3 8.14-8.18 13.32-10.51 4.1-1.85 8.82-1.66 13.28-1a72.69 72.69 0 0 1 28.69 10.63c4.33 2.76 8.61 6.07 13.7 6.66 9.72 1.13 17.26-7.68 25.24-13.34a44.83 44.83 0 0 1 37.78-6.42c11.27 3.25 21.42 11 33.15 11.16 14.71.19 26.64-11.45 40.5-16.36a46.69 46.69 0 0 1 44.34 7.78c3.85 3.16 7.26 7 11.74 9.2s10.6 2.21 13.74-1.67c1.52-1.87 2.12-4.37 3.69-6.21 6.42-7.5 20.39 2.41 28.17-3.66a10.69 10.69 0 0 0 3.57-5.87c2-7.77-2.94-16-9.63-20.38s-14.83-5.89-22.73-7.27c-19.09-3.32-38.43-6.66-57.73-5-14.05 1.19-27.75 5-41.74 6.78-19.89 2.56-40.05 1-60.1.36a682.53 682.53 0 0 0-128.36 7.94",
    fill: "#f8f8fa"
  }), React.createElement("path", {
    d: "M809.83 583.34v31.73a40.34 40.34 0 0 1-15.39-4.63c-8.88-4.59-16.87-11.15-26.47-14-29.9-8.76-60.26 21.57-90.67 14.8-11.67-2.6-22.24-10.58-34.18-10-11.25.52-20.54 8.41-30.51 13.63a69.1 69.1 0 0 1-63.09 0c-11.26-5.92-21.29-15.16-33.89-16.89-19.66-2.69-37.58 13.83-57.4 13.26-12.07-.35-22.91-7-33.7-12.37s-23.39-9.83-34.72-5.66c-5.06 1.86-9.36 5.29-14.07 7.88a29.29 29.29 0 0 1-5.85 2.48v-26.11a53 53 0 0 1 64.62 1.41c4.88 3.91 9.22 8.77 15 11.07 8.21 3.26 17.58.72 25.51-3.12s15.34-9 23.84-11.37c20.6-5.69 41.44 6.16 60.36 16.1 11.06 5.8 23.46 11.24 35.65 8.56 5.82-1.29 11.07-4.33 16.31-7.17 21.08-11.42 46.52-20.2 68.63-10.9 8.8 3.7 17.33 10.25 26.78 8.81 5.87-.9 10.78-4.78 15.54-8.33a205 205 0 0 1 32.13-19.57c5.38-2.62 11.25-5.08 17.18-4.15 8.13 1.25 13.84 8.35 19.43 14.4 5.07 5.44 11.86 10.74 18.96 10.14z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M809.83 586.76v31.74a40.34 40.34 0 0 1-15.39-4.63c-8.88-4.59-16.87-11.15-26.47-14-29.9-8.76-60.26 21.57-90.67 14.8-11.67-2.6-22.24-10.58-34.18-10-11.25.52-20.54 8.41-30.51 13.63a69.07 69.07 0 0 1-63.09-.06c-11.26-5.91-21.29-15.15-33.89-16.88-19.66-2.69-37.58 13.83-57.4 13.26-12.07-.35-22.91-6.95-33.7-12.37s-23.39-9.84-34.72-5.66c-5.06 1.86-9.36 5.29-14.07 7.88a29.85 29.85 0 0 1-5.85 2.47v-26.06a53 53 0 0 1 64.62 1.41c4.88 3.91 9.22 8.77 15 11.07 8.21 3.26 17.58.72 25.51-3.13s15.34-9 23.84-11.36c20.6-5.7 41.44 6.16 60.36 16.1 11.06 5.8 23.46 11.24 35.65 8.56 5.82-1.29 11.07-4.33 16.31-7.17 21.08-11.42 46.52-20.2 68.63-10.9 8.8 3.7 17.33 10.24 26.78 8.81 5.87-.9 10.78-4.78 15.54-8.33a205 205 0 0 1 32.13-19.57c5.38-2.62 11.25-5.08 17.18-4.15 8.13 1.25 13.84 8.35 19.43 14.4 5.07 5.45 11.86 10.73 18.96 10.14z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M393.2 569.5a54 54 0 0 1 41.3 11.08c4.89 3.91 9.23 8.77 15.05 11.07 8.2 3.26 17.56.72 25.5-3.13s15.34-9 23.84-11.36c20.6-5.69 41.44 6.16 60.36 16.1 11.06 5.8 23.46 11.24 35.65 8.56 5.82-1.28 11.07-4.32 16.3-7.16 21.09-11.43 46.53-20.21 68.64-10.91 8.81 3.7 17.34 10.25 26.78 8.81 5.87-.9 10.77-4.78 15.54-8.32a204.26 204.26 0 0 1 32.13-19.58c5.38-2.63 11.26-5.08 17.17-4.16 8.14 1.27 13.85 8.36 19.43 14.41s13.4 11.92 21.33 9.72c1.89-.53 3.66-1.5 5.61-1.72 3.35-.37 6.59 1.58 8.82 4.12 6.71 7.65 4.87 21.13-3.65 26.7-8.37 5.48-19.67 3-28.56-1.57s-16.87-11.15-26.47-14c-29.9-8.76-60.26 21.57-90.67 14.8-11.67-2.6-22.24-10.58-34.18-10-11.24.51-20.54 8.41-30.51 13.63a69.13 69.13 0 0 1-63.09-.06c-11.25-5.92-21.3-15.16-33.89-16.88-19.65-2.7-37.58 13.82-57.41 13.25-12.06-.35-22.9-7-33.69-12.36s-23.39-9.84-34.72-5.67c-5.05 1.86-9.35 5.29-14.08 7.87s-10.39 4.36-15.46 2.55c-3.93-1.4-8-6.66-6.4-11 1.23-3.42 7-7.13 9.54-9.64a54.48 54.48 0 0 1 29.79-15.15z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M809.83 647.92v42.57q-25.26 1.3-50.53 2.58c-27.19 1.38-54.42 2.77-81.64 2.24-23-.46-46-2.27-69-3-48.36-1.5-96.85 1.88-145.08-2-15.44-1.24-30.82-3.21-46.28-4.09a341.42 341.42 0 0 0-47.44.68v-40.1a37.51 37.51 0 0 1 4.37-.1 55.94 55.94 0 0 1 22 5.32c5.4 2.56 10.51 6 16.39 7 15.3 2.64 28.59-11.82 44.08-13 12.47-.92 23.67 6.81 34.38 13.28 2 1.24 4.35 2.49 6.71 2.14 2-.29 3.62-1.65 5.23-2.84 15.27-11.26 38.53-9.9 52.36 3.09 1.5 1.4 3 3 5 3.5 3.92 1 7.44-2.36 10.56-5 16.85-14.22 42.83-9.94 62.17.65 3.58 2 7.55 4.19 11.5 3.17 2.65-.69 4.7-2.72 6.82-4.46 16.47-13.51 41.24-11 60.51-1.91 1.86.88 3.83 1.83 5.87 1.6 2.46-.29 4.34-2.18 6.22-3.76a31.74 31.74 0 0 1 33.38-4.14c3 1.46 5.87 3.44 9.1 4.43 9.2 2.81 18.55-2.91 27.74-5.81a47.62 47.62 0 0 1 15.58-2.04z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M856.19 689.84l-96.89 4.94c-27.19 1.38-54.42 2.77-81.64 2.24-23-.46-46-2.27-69-3-48.36-1.5-96.85 1.87-145.08-2-15.44-1.24-30.82-3.21-46.28-4.09a344.45 344.45 0 0 0-52.16 1.14c-3.71.35-9.42 2.21-13 1.48-3.87-.79-2.39-1.23-1.13-4.9a31.9 31.9 0 0 0 1-3.32c1.06-4.49 1.25-9 1.69-13.68.56-5.95 1.44-12.49 6.36-16.54 3.87-3.19 9.23-3.83 14.25-3.67a55.94 55.94 0 0 1 22 5.32c5.4 2.56 10.51 6 16.39 7.05 15.3 2.64 28.59-11.82 44.08-13 12.47-.92 23.67 6.81 34.38 13.28 2 1.24 4.35 2.49 6.71 2.14 2-.29 3.62-1.65 5.23-2.84 15.27-11.26 38.53-9.9 52.36 3.09 1.5 1.4 3 3 5 3.5 3.92 1 7.44-2.36 10.56-5 16.85-14.22 42.83-9.94 62.17.65 3.58 2 7.55 4.19 11.5 3.17 2.65-.69 4.7-2.72 6.82-4.46 16.47-13.51 41.24-11 60.51-1.91 1.86.88 3.83 1.83 5.87 1.6 2.46-.29 4.34-2.18 6.22-3.76a31.74 31.74 0 0 1 33.38-4.14c3 1.46 5.87 3.44 9.1 4.43 9.2 2.81 18.55-2.91 27.74-5.81a48 48 0 0 1 60 30.52 45.52 45.52 0 0 1 1.86 7.57z",
    fill: "#f8f8fa"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("ellipse", {
    cx: 384.06,
    cy: 681.98,
    rx: 17.53,
    ry: 13.44
  }), React.createElement("ellipse", {
    cx: 449.45,
    cy: 681.44,
    rx: 17.53,
    ry: 13.44
  }), React.createElement("ellipse", {
    cx: 516.25,
    cy: 681.44,
    rx: 17.53,
    ry: 13.44
  }), React.createElement("ellipse", {
    cx: 595.6,
    cy: 681.44,
    rx: 17.53,
    ry: 13.44
  }), React.createElement("ellipse", {
    cx: 674.95,
    cy: 681.44,
    rx: 17.53,
    ry: 13.44
  }), React.createElement("ellipse", {
    cx: 743.19,
    cy: 681.44,
    rx: 17.53,
    ry: 13.44
  }), React.createElement("ellipse", {
    cx: 805.01,
    cy: 681.44,
    rx: 17.53,
    ry: 13.44
  })), React.createElement("ellipse", {
    cx: 384.06,
    cy: 683.69,
    rx: 17.53,
    ry: 13.44,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 449.45,
    cy: 683.15,
    rx: 17.53,
    ry: 13.44,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 516.25,
    cy: 683.15,
    rx: 17.53,
    ry: 13.44,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 595.6,
    cy: 683.15,
    rx: 17.53,
    ry: 13.44,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 674.95,
    cy: 683.15,
    rx: 17.53,
    ry: 13.44,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 743.19,
    cy: 683.15,
    rx: 17.53,
    ry: 13.44,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 805.01,
    cy: 683.15,
    rx: 17.53,
    ry: 13.44,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 437.42,
    cy: 445.82,
    r: 16.37,
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("circle", {
    cx: 637.46,
    cy: 444.97,
    r: 16.37,
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("circle", {
    cx: 536.31,
    cy: 424.78,
    r: 16.37,
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("circle", {
    cx: 738.68,
    cy: 424.78,
    r: 16.37,
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("path", {
    d: "M856.19 689.84l-96.89 4.94c-27.19 1.38-54.42 2.77-81.64 2.24-23-.46-46-2.27-69-3-48.36-1.5-96.85 1.87-145.08-2-15.44-1.24-30.82-3.21-46.28-4.09a344.45 344.45 0 0 0-52.16 1.14c-3.71.35-9.42 2.21-13 1.48-3.87-.79-2.39-1.23-1.13-4.9a31.9 31.9 0 0 0 1-3.32h502.27a45.52 45.52 0 0 1 1.91 7.51z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M339.48 683.15h522.36a17 17 0 0 1 17 17v2.2H322.45v-2.2a17 17 0 0 1 17.03-17z",
    fill: "#d4d5e0"
  }), React.createElement("rect", {
    x: 526.11,
    y: 275.9,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.8 631.116 50.963)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 480.54,
    y: 401.37,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 591.01 177.42)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 431.74,
    y: 546.65,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 542.202 322.73)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 553.76,
    y: 556.3,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 664.235 332.388)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 626.21,
    y: 550.86,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 736.718 326.96)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 728.33,
    y: 561.89,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 838.848 337.976)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 798.18,
    y: 545.78,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 908.719 321.871)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 491.42,
    y: 552.65,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 601.897 328.745)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 639.5,
    y: 567.29,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 749.985 343.41)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 700.61,
    y: 550.86,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 811.11 326.955)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 829.66,
    y: 545.78,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 940.195 321.874)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 686.3,
    y: 274.17,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 616.936 318.391)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 648.25,
    y: 271.33,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 578.877 315.547)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 586.46,
    y: 271.33,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 517.098 315.548)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 504.16,
    y: 397.16,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 434.794 441.384)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 508.85,
    y: 409.87,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 439.484 454.096)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 610.42,
    y: 398.17,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 541.06 442.39)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 570.13,
    y: 563.6,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 500.772 607.828)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 720.42,
    y: 404.72,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 651.065 448.936)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 765.66,
    y: 410.72,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 696.31 454.945)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 751.97,
    y: 545.78,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 682.622 590.01)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 845.21,
    y: 561.86,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 775.869 606.077)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 528.98,
    y: 552.65,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 459.62 596.89)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 461.09,
    y: 546.65,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 391.717 590.888)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 595.81,
    y: 557.16,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 526.456 601.395)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 668.5,
    y: 552.65,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-53.67 599.154 596.888)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 760.16,
    y: 278.03,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(54.68 770.75 202.801)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 679.99,
    y: 289.82,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(54.68 690.584 214.603)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 547.39,
    y: 405.93,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(54.68 557.998 330.705)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 587.48,
    y: 409.87,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(54.68 598.076 334.643)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 664.98,
    y: 409.87,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(54.68 675.579 334.637)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 689.21,
    y: 401.65,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(54.68 699.804 326.426)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 746.55,
    y: 404.72,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(54.68 757.141 329.492)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 788.4,
    y: 398.17,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(54.68 798.986 322.932)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 845.21,
    y: 401.65,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(54.68 855.793 326.42)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 670.87,
    y: 269.54,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 781.367 45.577)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 717.85,
    y: 267.46,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 828.363 43.51)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 653.35,
    y: 286.45,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 763.856 62.513)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 561.44,
    y: 289.82,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 671.939 65.857)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 725.06,
    y: 282.24,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 835.575 58.275)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 553.76,
    y: 269.54,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 664.234 45.599)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 602.04,
    y: 278.03,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 712.536 54.086)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 572.55,
    y: 401.37,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 683.039 177.433)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 644.67,
    y: 401.37,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 755.173 177.447)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 812.14,
    y: 404.72,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "matrix(.96 .29 -.29 .96 90.95 -257.66)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 829.66,
    y: 404.72,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 940.205 180.808)",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 621.31,
    y: 289.82,
    width: 3.13,
    height: 8.66,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(16.71 731.795 65.865)",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 437.42,
    cy: 770.77,
    rx: 179,
    ry: 16.1,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 198.97,
    cy: 702.99,
    rx: 28.6,
    ry: 2.9,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 122,
    cy: 775.51,
    rx: 28.6,
    ry: 2.9,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 907.93,
    cy: 766.81,
    rx: 28.6,
    ry: 2.9,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 838.42,
    cy: 797.5,
    rx: 28.6,
    ry: 2.9,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 756.21,
    cy: 747.96,
    rx: 28.6,
    ry: 2.9,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 626.8,
    cy: 815.24,
    rx: 28.6,
    ry: 2.9,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M540.61 426.59l-12.73 27.07s-1.88 5.08-3.09 6-6.55 17-6.55 17l-13.67 21-.93 1.43-5.35-1.48-3.75-14 .22-4.07v-.52s8.45-8.83 10.32-9.5c0 0 1.47.17 4.29-6.68s5.35-8.32 5.35-8.32l1.47-5L532 424.34s13.26-19 16.87-10.57-8.26 12.82-8.26 12.82z",
    fill: "#ffd2c6"
  }), React.createElement("path", {
    d: "M386.64 455.07a18.29 18.29 0 0 0-1.48 4.52c-.09.4-.17.81-.27 1.24-.88 4.51-1.48 10.19-1.78 13.48-.15 1.66-.22 2.72-.22 2.72s-32-2.14-26.44-7.5a11.76 11.76 0 0 0 2.93-5.31q.24-.86.42-1.74a30.05 30.05 0 0 0 .5-4.05v-1a42.21 42.21 0 0 0-.32-6.62s10.4-.06 18.24.84c5.31.55 9.42 1.59 8.42 3.42z",
    fill: "#d38884"
  }), React.createElement("path", {
    d: "M487.72 618.82a2.81 2.81 0 0 1-.43 1.3c-1.46 2.14-9.77 45.93-9.77 45.93.67 3-1.2 8.85-2.41 11.53s-3.89 16.61-3.89 16.61-.66 30-2.4 34.68.56 14.73.56 14.73c-.17 4.62 2.6 9.5 4.25 12 .12.16.23.32.32.46.54.77.89 1.21.89 1.21a7.12 7.12 0 0 0 1.88 2.31c.12.1.24.2.37.29a21.33 21.33 0 0 0 7.51 3.17l.26.06c1.07.23 1.77.33 1.77.33l.66 3.62-7.09 1.47-13.52.93s-15.94 1.21-12.32-5.89a13.31 13.31 0 0 0 .65-1.5c.13-.34.26-.7.37-1.06 2.17-6.83.7-15.12.7-15.12L453 721.65c-5.08-22.5 4-47.55 4-47.55s-.8-2 .95-7.1 0-16.2 0-16.2-.93-14.33-2.14-21.42a43.61 43.61 0 0 1-.49-9 45.09 45.09 0 0 1 .49-5.28l30.53-4s1.75 4.9 1.38 7.72z",
    fill: "#ffd2c6"
  }), React.createElement("path", {
    d: "M487.29 767.07l-7.09 1.47-13.52.93s-15.94 1.21-12.32-5.89a13.31 13.31 0 0 0 .65-1.5c.13-.34.26-.7.37-1.06a24.62 24.62 0 0 1 8.08 1.63c4.54 1.74 8-2.82 8-2.82l2.2-4.21.32-.61c.54.77.89 1.21.89 1.21a7.33 7.33 0 0 0 2.25 2.6l-.37.78-2.17 4.47s2.74.28 6.49.88a2.9 2.9 0 0 0 3.53-1.93l.26.06c1.07.23 1.77.33 1.77.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M493.86 770.38c-.53 2.41-15.47 3.15-15.47 3.15s-8.3-.8-10.64 1.14-9.18 1.48-9.45 1.48-3.88-.14-5.29-6.62c-1.37-6.32 1.84-7.43 2-7.48a24.24 24.24 0 0 1 8.45 1.64c4.54 1.74 8-2.82 8-2.82l2.48-4.8c.54.77.89 1.21.89 1.21a7.33 7.33 0 0 0 2.25 2.6l-2.51 5.3s2.74.27 6.49.87c3 .49 3.65-2 3.79-2.94a3.81 3.81 0 0 0 0-.41s2.34.68 5.22 1.48a5.38 5.38 0 0 1 3.79 6.2z",
    fill: "#626696"
  }), React.createElement("path", {
    d: "M521.99 650.74c-.36 2.14-.72 7.68-.72 7.68 1.25 4.64-2 15.67-2 15.67l-1.61 6.3c.72 8-4.41 27.67-4.41 27.67s-3.44 18.21-5.23 26.08a21.55 21.55 0 0 0 .93 13.13 2.66 2.66 0 0 0 .14.33 3.39 3.39 0 0 0 .11.43 4.71 4.71 0 0 0 .19.64 9.48 9.48 0 0 0 1.76 3 8.9 8.9 0 0 0 1 1v.06a19.49 19.49 0 0 0 5.69 3.5c.31.13.61.25.9.35a27 27 0 0 0 2.84.89l.33.08-.72 4.21-9.46-2.42-12.68-4.12-6.11-3.59s.06-.34.19-1v-.11l.18-1c1-5.53 3.4-21 2.19-32.38-1.51-14.1 4.36-33.57 5.79-38.21a23.12 23.12 0 0 0 1.08-8.22c-2.33-3.39-2.86-17-2.86-17s-4.29-8.75-7.84-18a47.62 47.62 0 0 1-2.55-9.38 33.08 33.08 0 0 1-.51-6.86s28.76-26.25 31.92-.84c.1.86.2 1.68.3 2.49 2.76 23.27 1.5 27.55 1.16 29.62z",
    fill: "#ffd2c6"
  }), React.createElement("path", {
    d: "M521.99 757.53l-.72 4.21-9.46-2.42-12.68-4.12-6.19-3.57s.06-.34.19-1v-.11l.18-1 .89-.09h.08a11.68 11.68 0 0 1 5.3.72c2.07.77 4.77 1.66 5.33 1.28a6.68 6.68 0 0 1 3-.53l1.33-2.83.19-.43a9.32 9.32 0 0 0 1.76 3 9.06 9.06 0 0 0 1 1v1l-.08 1.45a18.76 18.76 0 0 0 4.56 2.1 2.67 2.67 0 0 0 1.26 0c.31.13.61.25.9.35a27 27 0 0 0 2.84.89z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M517.25 766.51c-2.64-.77-9-2-10-1s-9.87 0-9.87 0a5.37 5.37 0 0 1-4.55-2.68c-1.83-2.86-.35-12.1-.35-12.1l.65-.06 1.09-.11h.08a11.82 11.82 0 0 1 5.3.72c2.07.77 4.77 1.66 5.33 1.28a6.68 6.68 0 0 1 3-.53l1.51-3.32a9.48 9.48 0 0 0 1.76 3 11 11 0 0 0 1 1l-.13 2.46a18.76 18.76 0 0 0 4.56 2.1 1.82 1.82 0 0 0 2.18-.7 1.47 1.47 0 0 0 .16-.36c.08.15 1 .45 3.73 1.24 3-.17 5.94 1.15 7.28 5.25s-10.04 4.56-12.73 3.81z",
    fill: "#626696"
  }), React.createElement("path", {
    d: "M487.72 618.82l-1.63.5a23.64 23.64 0 0 1-3.94.83c-8.45 1.19-22.38.47-26.81.19a45.09 45.09 0 0 1 .49-5.28l30.53-4s1.73 4.94 1.36 7.76z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M514.36 611.41s-11.21 1.74-20.33 3.73c-3 .66-5.86 1.36-7.94 2a22.61 22.61 0 0 1-3.94.84c-10.16 1.42-28.2.11-28.2.11-4.95-16.07 6-36.3 6-36.3-.25-1.61 2.28-6.56 2.28-6.56l.05-.16 1.56-5.73h41.65l.51 2.46 1.06 5 6.54 31.05z",
    fill: "#626696"
  }), React.createElement("path", {
    d: "M520.81 621.15l-.25.11-4.87 2.16c-5.28 2.43-21.07 2.89-26.59 2.94a33.08 33.08 0 0 1-.51-6.86s28.76-26.25 31.92-.84c.1.86.2 1.68.3 2.49z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M521.58 618.66l-1 .45-4.87 2.17c-5.37 2.47-21.67 2.91-26.89 2.93h-1.37c-2.41-.07-4.82-2.33-4.82-2.92 0-.32-.25-1.91-.46-3.27l-.34-2s-10.72-4.64-16.2-8.39c-4.09-2.78-3.07-22.57-2.27-32.52.28-3.43.52-5.69.52-5.69l42.16 2.46 5.92.34 3.38.75.9.2s2.42 17.68 3.62 19.14.41 6.43.27 9.25a17.2 17.2 0 0 1-.4 3.61s1.74 5 1.33 7.74a15.5 15.5 0 0 0 .52 5.75z",
    fill: "#626696"
  }), React.createElement("path", {
    d: "M331.28 607.18c-10.9-.37-2.86-23-1.61-26.1s-1.87-10.51-1.87-10.51-3.67-21.61-3.67-23a58.09 58.09 0 0 0-1.24-8.75c-.54-2 .17-6.6 1.42-8.57s1.07-9.82 1.07-9.82v-10.21l2.42-3.22 6.22 5.87 1.72 1.63 3 11.38-1.08 16.3-.49 15.89 3.77 22s1.23 27.46-9.66 27.11z",
    fill: "#d38884"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M334.67 515.57l-9.29-3.84v-1.51l2.42-3.22 6.21 5.87.66 2.7z"
  }), React.createElement("path", {
    d: "M330.38 492.36a43.22 43.22 0 0 0-2.57 9.1 40.61 40.61 0 0 1-2.43 8.75l10.36 4.29z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M330.38 492.36a43.22 43.22 0 0 0-2.57 9.1 40.61 40.61 0 0 1-2.43 8.75l10.36 4.29z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M412.57 717.85l-.85 1.82s-.94 6.07-.94 6.21-2.67 4.19-2.67 4.19l-6.74 1.43-2.86-.34a40.46 40.46 0 0 0-.76-5c-.11-.46-.22-.93-.35-1.41a37.12 37.12 0 0 0-4.7-10.66s-5-12.33-6.78-13.93-8.57-17.86-7.86-21.78c.39-2.17.08-9.38-.27-15.4-.29-4.91-.62-9-.62-9l17-10 2 3.12 1.18 1.85s0 .36-.07.94v.22a30.9 30.9 0 0 1-1.51 7.41s-1.28 9.11 0 10.72 5.3 23.09 6.2 33c0 .31.06.61.08.9.35 4.56 3.18 8.63 6 11.61.18.2.38.39.57.58a39.42 39.42 0 0 0 3.95 3.52z",
    fill: "#d38884"
  }), React.createElement("path", {
    d: "M398.51 731.16l2.86.34 6.74-1.43s2.67-4.06 2.67-4.19.94-6.21.94-6.21l.85-1.82.11-.22a38.59 38.59 0 0 1-4.64-3.82l-.47-.46s1 5.9-4.17 8.54c-2.49 1.28-4.53 2.26-6 2.94z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M413.75 718.7l-1 2s-.93 6.06-.93 6.2-2.68 4.19-2.68 4.19l-6.74 1.43-3.87-.46c0-.78-.13-1.88-.33-3.22-.12-.82-.28-1.72-.49-2.68 1.43-.66 3.75-1.77 6.69-3.28 5.13-2.63 4.17-8.54 4.17-8.54a40.2 40.2 0 0 0 3.52 3.13c.75.6 1.32.99 1.66 1.23z",
    fill: "#ceddf9"
  }), React.createElement("path", {
    d: "M413.75 718.7l-1 2s-.93 6.06-.93 6.2-2.68 4.19-2.68 4.19l-6.74 1.43-3.87-.46c0-.78-.13-1.88-.33-3.22a12.8 12.8 0 0 1 2.45.33s9.21 2 9.64-5.31c.26-4.14 1.12-5.76 1.8-6.39.75.6 1.32.99 1.66 1.23z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M413.08 718.22s-2.3-.51-2.74 6.76-9.65 5.32-9.65 5.32-4.51-1.12-4.55.75a17.65 17.65 0 0 0 1.21 5s.26 4.33 1.11 5.36.31 4.86.31 4.86.36 2.86 7.46 0c0 0 6.35-1.3 11.61-9.19.17-.27-.63-1.08 4-2.73s17.77-12.23 16.74-17.41a4.38 4.38 0 0 0-3.12-3.71 5.39 5.39 0 0 0-4.11.55 34.91 34.91 0 0 1-3.84 1.78 19 19 0 0 1-5.49 1.31 20.58 20.58 0 0 0-4.25.81c-1.58.52-3.56.94-4.69.54z",
    fill: "#cc8294"
  }), React.createElement("path", {
    d: "M361.01 668.19a12.55 12.55 0 0 0-2.58 3c-2.61 4-4.16 9.51-5.93 11.89-2.27 3.09-2.88 9.11-2.88 9.11-.6 4-9 25-11.25 28.8s-5.43 13.91-5.43 13.91c-1.93 2.42-1.81 6-1.62 7.72 0 .3.07.54.1.7s.05.28.05.28l-.05.1-3.1 5.26-9.85-1.36-5.09-3.47a15.58 15.58 0 0 0 1.11-2.1c2.72-6.07 4.66-16.91 4.66-16.91s2.74-12.39 2.54-15.27.8-11.79.8-11.79 7.7-23.69 10.13-27.58a11.07 11.07 0 0 0 1.86-5.09 4.38 4.38 0 0 0-.05-1.11l3.33-3.31s27.53 3.82 23.25 7.22z",
    fill: "#d38884"
  }), React.createElement("path", {
    d: "M331.48 742.53s0 .3-.05.79v.38l-3.1 5.26-9.85-1.36-5.09-3.47a15.58 15.58 0 0 0 1.11-2.1c2.47-.7 8.14 1.3 8.14 1.3s6.12 1.17 8.69-.71z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M329.07 756.58l-10 2.43-9.13-6.78.47-3.81a7 7 0 0 0 1.69-1.53 6.14 6.14 0 0 0 1.32-2.76c.54-2.8 9.25.27 9.25.27s6.36 1.21 8.84-.8a15.67 15.67 0 0 0 .43 5.47 4.1 4.1 0 0 0 1.47 2.19c2.53 1.81-4.34 5.32-4.34 5.32z",
    fill: "#ceddf9"
  }), React.createElement("path", {
    d: "M329.07 756.58l-10 2.43-9.13-6.78.47-3.81a7 7 0 0 0 1.69-1.53h2c1.54.14 5.15 6.71 5.15 6.71 9.07.6 11.77-2.36 12.73-4.54a4.1 4.1 0 0 0 1.47 2.19c2.49 1.82-4.38 5.33-4.38 5.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M319.22 754.71s-3.61-6.56-5.15-6.69a32.88 32.88 0 0 0-3.89 0s-4 9.51-5.49 10.38-3.61 5.35-3.61 5.35 10.6 10.25 20.86 8.32a21.1 21.1 0 0 1 9.39 2.34c4.76 2.48 24.58.6 27-3.75 1.81-3.26 2.52-5.64.93-7.38a4.26 4.26 0 0 0-3.73-1.26c-2.49.34-8.09.27-13-5.76 0 0-9-8.28-9.78-8.29s.6 7.68-13.53 6.74z",
    fill: "#cc8294"
  }), React.createElement("path", {
    d: "M397.3 650.07l-.08.09c-.61.67-5 5.46-6.3 5.81a62.08 62.08 0 0 0-6.43 2.85s-2.68 3.57-4.82 3.75a7.91 7.91 0 0 0-1.88.5c-.29-4.91-.62-9-.62-9l17-10 2 3.12c.45 1.26.95 2.42 1.11 2.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M335.56 581.07s-6.61 8.6 0 20 13.57 17.15 13.57 17.15l22.5 46.6s5.89-3.21 8-3.39 4.82-3.75 4.82-3.75a63.93 63.93 0 0 1 6.43-2.86c1.43-.36 6.38-5.89 6.38-5.89s-2.45-5.36-1.92-6.79-1.61-5-1.61-5a29.61 29.61 0 0 1-1.42-5.53c0-1.43-2.33-4.82-2.33-4.82s-2.32-3.58-2.32-5.54-3.39-9.64-3.39-9.64l-.89-33.93z",
    fill: "#ceddf9"
  }), React.createElement("path", {
    d: "M397.3 648.96s-4.95 5.53-6.38 5.89a64.34 64.34 0 0 0-6.43 2.85s-2.68 3.58-4.82 3.75a17.58 17.58 0 0 0-4.39 1.58c-1.92.88-3.64 1.82-3.64 1.82l-22.5-46.6a48.89 48.89 0 0 1-5.47-5.61 76.5 76.5 0 0 1-8.11-11.57 19.31 19.31 0 0 1-2.56-13.89 16 16 0 0 1 2.56-6.13l16-1.13 31.85-2.24.27 10 .62 23.89s.53 1.2 1.17 2.78c1 2.41 2.23 5.68 2.23 6.87 0 2 2.31 5.54 2.31 5.54s2.33 3.39 2.33 4.82a30 30 0 0 0 1.42 5.54s2.14 3.56 1.61 5 1.93 6.84 1.93 6.84z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M361.01 668.19a12.55 12.55 0 0 0-2.58 3c-9.72.7-21-4.38-23.94-5.78a4.38 4.38 0 0 0-.05-1.11l3.33-3.31s27.52 3.8 23.24 7.2z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M389.67 591.64s-1.43 5-2 7.14-1.61 12.68-1.61 12.68l-.62 3-10.16 48.61-2.22 10.57c-3.93 2.15-13.75-3.57-13.75-3.57-11.43 1.25-25.54-6.07-25.54-6.07s2.33-7.5 1.79-11.25 3.22-6.79 3.22-6.79c-.89-3.39 2.31-18.21 2.31-18.21s.72-5.53 3.4-7-.36-3.57-1.08-4.82c-.35-.61-.09-2 .26-3.28s.82-2.43.82-2.43c-6.81-6.8-7.86-17.45-7.87-23.36a39.28 39.28 0 0 1 .19-4.31l14.76-2.59 32.2-5.63 3.28 10.11.83 2.54z",
    fill: "#ceddf9"
  }), React.createElement("path", {
    d: "M386.64 455.07a18.29 18.29 0 0 0-1.48 4.52c-.09.4-.17.81-.27 1.24-3.11 2-5 2-9 2-1.38 0-2.14-2.62-3.43-2.88 0 0-1.95-7-2.5-1.11-3.74-.77-7 2.16-9.62-.39v-.05-1a42.21 42.21 0 0 0-.32-6.62s10.4-.06 18.24.84c5.27.58 9.38 1.62 8.38 3.45z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M394.01 443.07a19.9 19.9 0 0 1-19.9 19.89 20.43 20.43 0 0 1-4-.4 19.9 19.9 0 1 1 23.9-19.49z",
    fill: "#d38884"
  }), React.createElement("path", {
    d: "M383.11 474.28c-.15 1.66-.22 2.72-.22 2.72s-32-2.14-26.44-7.5a11.76 11.76 0 0 0 2.93-5.31l13.86 2.27s3.92 3 7 5.89a12.31 12.31 0 0 0 2.87 1.93zM387.88 588.07a10.2 10.2 0 0 1-4.19-.32 7.48 7.48 0 0 1-1.7-.75c-2.68-1.6-11.61.37-11.61.37s-24.29 1.6-25.36 0c-.61-.92-4.88-.79-8.4-.51-1.42.12-2.73.26-3.62.36a16 16 0 0 1 2.56-6.13l16-1.13 32.2-5.63 3.28 10.11c.39 2.08.84 3.63.84 3.63z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M373.24 467.53l-17.43-2.85a5.15 5.15 0 0 1-3.28 2.85c-2.33.54-12.68 5.9-17.33 12.33l-4.64 6.42s-3.75 4.65-2.5 8.4 2.68 16.39 2.68 16.39l1.79 14.1s3.39 10.18 2.32 14.64.53 23.22.53 23.22l-3.57 23.21s12.14-1.61 13.22 0 25.35 0 25.35 0 8.93-2 11.61-.36a9.67 9.67 0 0 0 5.89 1.08s-2.14-7.33-.89-11.43.89-11.61.89-11.61 1.79-10.89.89-12.86 2-9.1 2-9.1l9.46-49.82s-1.14-8.93-6.2-12-10.76-3.93-13.8-6.78-6.99-5.83-6.99-5.83z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M381.27 516.64v5.89l5.51 14.82 2 13.75s3.58 9.83 3.58 13.22 8.75 19.82 8.75 19.82 2.38 5.53 1.19 6.61-11.55 24.64 1.48 23.92 8.93-25.35 8.93-25.35l-1.77-10.72s-2.5-26.78-2.5-28.75c0 0-3.22-11.42-3.57-13.92s-2.68-15.18-2.68-15.18l-2-8.22z",
    fill: "#d38884"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M375.06 535.21l-19.41 11.12-6.03 9.1 8.03-8.17 17.41-12.05zM369.18 556.51s-8.84 5.75-13 5.75-13.8 9.91-13.8 9.91 13.66-8.82 14.73-8.56 12.07-7.1 12.07-7.1zM346.54 559.59s-8.3 7.5-6.16 8.3 13.26-8.3 13.26-8.3zM383.24 532.8s-6.43 8.71-4.69 8.57 6.7-5.09 6.7-5.09zM384.18 541.37s-7 7.9-6.7 9.91 6.7-9.91 6.7-9.91zM385.94 545.32s-4.69 8.37-2.68 10.11 2.68-10.11 2.68-10.11zM379.94 523.83s-3.48 5.89-.94 6.29 2.8 0 2.8 0zM380.83 502.27a61.63 61.63 0 0 1-3.57 10.51 46.42 46.42 0 0 1-1.39-5.27 36.51 36.51 0 0 1 4.96-5.24zM391.46 433.28a9.08 9.08 0 0 1-1.35 2.08 15.08 15.08 0 0 0-2.42 2.77c-.75 1.43-.62 3.14-.87 4.74s-1.27 3.35-2.87 3.4a6.12 6.12 0 0 1-2.36-.7 2.39 2.39 0 0 0-2.35.07 2.65 2.65 0 0 0-.75 1.77 23.4 23.4 0 0 0-.23 4.18c0 .56 0 1.1.09 1.66.17 1.79.53 3.72-.32 5.31a6.36 6.36 0 0 1-3.3 2.65 19.7 19.7 0 0 1-4.63 1.3 51.42 51.42 0 0 1-9.13.3 2.5 2.5 0 0 1-.81-.13 1.18 1.18 0 0 1-.35-.23 30.06 30.06 0 0 0 .54-5.08 19.89 19.89 0 1 1 31.12-24.09z"
  }), React.createElement("path", {
    d: "M383.13 416.39c-1.82-.19-3.54.79-5.34 1.18-3.7.82-7.49-.87-11.29-.85a20.71 20.71 0 0 0-9.28 2.77 22.39 22.39 0 0 0-6.2 4.33 10.08 10.08 0 0 0-2.94 6.81c0 1.48.43 3-.14 4.38a13.12 13.12 0 0 1-1.35 2.07 6.06 6.06 0 0 0-.63 5.11c.58 1.74 1.92 3.11 3.05 4.56 2.44 3.15 4 6.9 6.17 10.23a30.81 30.81 0 0 0 3.21 4.08 2.27 2.27 0 0 0 .69.55 2.22 2.22 0 0 0 .81.13c4.66.13 9.49.23 13.77-1.6a6.4 6.4 0 0 0 3.3-2.65c.84-1.59.5-3.52.33-5.32a24.29 24.29 0 0 1 .13-5.84 2.65 2.65 0 0 1 .75-1.76 2.39 2.39 0 0 1 2.35-.07 6.12 6.12 0 0 0 2.35.7c1.61-.05 2.62-1.81 2.88-3.41s.11-3.3.87-4.73a15.08 15.08 0 0 1 2.42-2.77 11.37 11.37 0 0 0 2-10.07c-.98-3.32-4.22-7.46-7.91-7.83z",
    fill: "#1e1637"
  }), React.createElement("circle", {
    cx: 476.45,
    cy: 454.59,
    r: 17.28,
    fill: "#ffd2c6"
  }), React.createElement("path", {
    d: "M468.01 461.8s1.21 16.36-2.14 20.11-12 10.85-12 10.85l2.68 11.11 15.13 1.74 17.68-18.88-4-4.95s-3.08-10.45-.54-15.67-16.81-4.31-16.81-4.31z",
    fill: "#ffd2c6"
  }), React.createElement("path", {
    d: "M504.57 497.74l-.93 1.43-5.35-1.48-3.75-14 .22-4.07 1.1-1.59s5.9.14 5.64 5.5c-.25 4.7 2.44 12.43 3.07 14.21zM516.22 575.26s-4.26.95-9.14 1.59-10.52 1-12.82-.39c-3.88-2.29-24.89-1.64-30.92-1.4h-1l1.56-5.73h41.65l.51 2.46 5.92.34 3.38.75.86 2.38z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M494.8 479.07s5.89.13 5.62 5.49 3.22 14.6 3.22 14.6l-1.34 3.08s-1.88 7.5-.4 9.37 6.83 1.88 3.75 17.28c0 0-.67 11.51.94 15.26s1.6 12.73 4 16.48 5.64 12.44 5.64 12.44-17.41 3.89-22 1.21-32.54-1.34-32.54-1.34.13-4.69 0-5.22a4.41 4.41 0 0 1 .67-3.42c.94-1.27 2.41-3.41 1.61-5.29s2-4.63.53-7.54-3.27-3.48-2.91-5.07-.57-3.73-1.64-5.07-8.31-15.49-8.31-15.49l-1.2-6.61s-9.32-6.83-9.15-10 3.52-7.67 3.52-7.67l9-8.8s5 5.35 9.77 3.48 15.18-10.85 15.18-10.85 3.71-2 4-3.48 2.54-.13 2.54-.13 3.35-1.84 4-1.19 3.61 1.19 3.61 1.19z",
    fill: "#ffcde5"
  }), React.createElement("path", {
    d: "M444.17 507l-2.85 2.23s-2.9 5.22-3.57 14.6-3.62 22.61-3.62 22.61l-5.62 10.07s-9.25 19.4-10.45 24.56-6.7 13.87-6.7 13.87-18.61 16.73-5.62 19.75 13.39-13.32 13.39-13.32 3-3.35 3.52-5.62 17-31.41 17-31.41 5.76-7.83 4.55-12c0 0 7.5-17.63 7.5-22a78.37 78.37 0 0 0-1.2-11l1.2-9.24z",
    fill: "#ffd2c6"
  }), React.createElement("path", {
    d: "M482.75 543.92s-13.13 6.87-15.67 7.23 11.11-1.47 11.11-1.47zM493.46 549.27s-17.41 5.9-25 4.83c-.04-.03 18.97 3.61 25-4.83z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M494.53 551.2s-15.67 9.86-24.91 8.25c0 0 21.56 4.29 24.91 2l-9.59-2.67s10.66-5.66 9.59-7.58zM476.47 424.19c-4.52-.91-9.55-.36-13.18 2.5-2.68 2.11-4.46 5.33-7.49 6.91a43.72 43.72 0 0 1-4.9 1.72 14.14 14.14 0 0 0-8.62 15.21c.47 2.65 1.71 5.1 2.33 7.73 1.09 4.67.13 9.56-1.06 14.21a149.89 149.89 0 0 1-14.88 36.92 3.93 3.93 0 0 0-.74 2.48 3.46 3.46 0 0 0 .91 1.58c6.2 7.16 16.27 9.61 25.72 9.94 3.49.11 7.13 0 10.2-1.7a15.33 15.33 0 0 0 5-4.56 24.15 24.15 0 0 0 4.61-15.56c-.25-4.49-1.76-9-.63-13.38a3.62 3.62 0 0 1 .81-1.64c1-1 2.71-.77 4.15-.94 3.94-.45 6.47-4.6 6.94-8.53s-.51-7.88-.54-11.84a24.8 24.8 0 0 1 4.67-14.57c1.31-1.81 3-3.57 3.42-5.83.55-2.83-1.08-4.9-2.49-7.13-2.2-3.48-3.27-7.53-6.62-10.18a17.83 17.83 0 0 0-7.61-3.34z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M475.4 423.12c-4.52-.91-9.55-.36-13.18 2.5-2.68 2.11-4.47 5.33-7.49 6.91a43.72 43.72 0 0 1-4.9 1.72 14.14 14.14 0 0 0-8.62 15.21c.47 2.65 1.71 5.1 2.33 7.73 1.09 4.67.13 9.56-1.06 14.21a149.89 149.89 0 0 1-14.88 36.92 3.87 3.87 0 0 0-.74 2.48 3.51 3.51 0 0 0 .91 1.58c6.19 7.15 16.27 9.61 25.72 9.93 3.48.12 7.13 0 10.19-1.69a15.26 15.26 0 0 0 5-4.56 24.15 24.15 0 0 0 4.61-15.56c-.25-4.49-1.76-9-.63-13.38a3.52 3.52 0 0 1 .81-1.64c1-1 2.71-.77 4.15-.94 3.93-.45 6.47-4.6 6.94-8.53s-.51-7.88-.54-11.84a24.8 24.8 0 0 1 4.67-14.57c1.31-1.81 3-3.57 3.42-5.83.55-2.83-1.08-4.9-2.49-7.14-2.2-3.47-3.27-7.53-6.62-10.17a17.83 17.83 0 0 0-7.6-3.34z",
    fill: "#985c7e"
  }), React.createElement("path", {
    d: "M402.26 501.07c-.72 2.85 0 7.32 0 7.32-.18 2 0 12.85 0 12.85-5.89-1.79-20.89 1.79-20.89 1.79l-1.79-5.36a13 13 0 0 1-2.23-4.4 46.42 46.42 0 0 1-1.41-5.2 110.33 110.33 0 0 1-1.76-11.22c-.74-5.68 7.7-11.78 14.09-15.18s12 11.07 12 11.07 2.67 5.5 1.99 8.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M402.26 500.07c-.72 2.85 0 7.31 0 7.31-.18 2 0 12.86 0 12.86-5.89-1.79-20.89 1.79-20.89 1.79l-1.79-5.36a13 13 0 0 1-2.23-4.4 46.42 46.42 0 0 1-1.39-5.27 110.33 110.33 0 0 1-1.76-11.22c-.74-5.68 7.7-11.78 14.09-15.18s12 11.07 12 11.07 2.65 5.5 1.97 8.4z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M469.62 590.57s3.44 16.07 9.15 20.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M390.94 424.22a12 12 0 0 0-1.32-2.87c.1.25.18.49.25.73a11.38 11.38 0 0 1-2 10.07 15.13 15.13 0 0 0-2.42 2.77c-.76 1.42-.61 3.14-.87 4.73s-1.26 3.35-2.88 3.41a6.3 6.3 0 0 1-2.35-.7 2.39 2.39 0 0 0-2.35.07 2.63 2.63 0 0 0-.75 1.76 24.81 24.81 0 0 0-.13 5.84c.17 1.8.51 3.72-.33 5.32a6.34 6.34 0 0 1-3.3 2.64c-4.28 1.84-9.11 1.73-13.76 1.6a2.07 2.07 0 0 1-.82-.12 2.26 2.26 0 0 1-.68-.55 30.71 30.71 0 0 1-3.22-4.08c-2.19-3.33-3.73-7.08-6.17-10.23-.67-.87-1.41-1.7-2-2.6 0 .06 0 .12.05.18.59 1.74 1.92 3.11 3.05 4.56 2.44 3.15 4 6.9 6.17 10.23a30.08 30.08 0 0 0 3.22 4.08 2.12 2.12 0 0 0 .68.55 2.27 2.27 0 0 0 .82.13c4.65.13 9.48.23 13.76-1.6a6.38 6.38 0 0 0 3.31-2.65c.84-1.59.49-3.52.32-5.32a24.82 24.82 0 0 1 .13-5.84 2.65 2.65 0 0 1 .75-1.76 2.41 2.41 0 0 1 2.36-.07 6 6 0 0 0 2.34.7c1.62-.05 2.63-1.81 2.88-3.41s.12-3.3.87-4.73a15.47 15.47 0 0 1 2.42-2.77 11.37 11.37 0 0 0 1.97-10.07z",
    opacity: 0.2
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M442.22 453.07c-.18-.63-.38-1.26-.6-1.88.18.62.39 1.25.6 1.88zM491.08 439.07a5.62 5.62 0 0 1-.07 1.52c-.44 2.26-2.11 4-3.42 5.83a24.85 24.85 0 0 0-4.65 14.54c0 3.95 1 7.91.54 11.84s-3 8.07-6.94 8.53c-1.44.17-3.14-.11-4.16.93a3.66 3.66 0 0 0-.8 1.64c-1.13 4.35.37 8.9.63 13.39a24.13 24.13 0 0 1-4.61 15.55 15.4 15.4 0 0 1-5 4.57c-3.06 1.66-6.66 1.81-10.18 1.66-9.3-.32-19.19-2.71-25.4-9.6a2.42 2.42 0 0 0-.16 1.3 3.51 3.51 0 0 0 .91 1.58c6.19 7.15 16.27 9.61 25.72 9.93 3.48.12 7.13 0 10.19-1.69a15.26 15.26 0 0 0 5-4.56 24.15 24.15 0 0 0 4.61-15.56c-.25-4.49-1.76-9-.63-13.38a3.52 3.52 0 0 1 .81-1.64c1-1 2.71-.77 4.15-.94 3.93-.45 6.47-4.6 6.94-8.53s-.51-7.88-.54-11.84a24.8 24.8 0 0 1 4.67-14.57c1.31-1.81 3-3.57 3.42-5.83a6.67 6.67 0 0 0-1.03-4.67z"
  })), React.createElement("path", {
    d: "M131.99 727.7s-37.29 19.26-18 42c0 0 1.82 5 7.06 4.58 0 0-1.05-1.91 3-3.43a19.57 19.57 0 0 0 4-2.14 9.49 9.49 0 0 0 3.61-4.82s7.63-10.21 1.72-29.1c0 0 .76-5.34.09-6.2l-4.53 6.18s4.69 3.14 5.22 7.76c0 0-4.88-7.75-5.93-6.87-.22.18-2.26 3.4-2.26 3.4s8.12 5.51 8.73 12.66c0 0-4.58-10-9.51-11.45l-2.79 5s8.87 5.4 9.87 13.52c0 0-5.15-10.3-10.41-12.38l-2.08 5.33s8.55 5.44 9.34 12.2c0 0-7.15-11.3-9.73-10.95 0 0-1.61 5-1.39 6.55 0 0 6 4 6.15 8 0 0-5.58-7-6.44-6.58 0 0-.36 7.08 1.36 10.77 0 0-2.93-5.26-2.47-10.77a11.84 11.84 0 0 0-3.58 5.76s-1.61-3.9 3.69-7.48c0 0 .5-5.51 1.11-6.19 0 0-5.73 2.79-8.16 6.23 0 0 .9-5.12 8.66-7.66l2-5.4s-7.76 3.29-10.15 6.19c0 0 1.72-5.08 10.76-7.51l2.69-5s-6.91 2.32-10.27 5c0 0 2.61-4.36 11.09-6.37l2.18-3.11s-5 1.79-6.4 2.43-1.68.32-1.68.32a18.08 18.08 0 0 1 9-4.07s4.8-6.03 4.45-6.4zM762.63 701.76s-37.3 19.27-18 42c0 0 1.81 5 7.06 4.58 0 0-1.05-1.91 3-3.43a19.57 19.57 0 0 0 4-2.14 9.47 9.47 0 0 0 3.61-4.83s7.63-10.2 1.72-29.09c0 0 .76-5.34.09-6.2l-4.53 6.21s4.69 3.15 5.22 7.77c0 0-4.88-7.75-5.94-6.87-.21.18-2.25 3.4-2.25 3.4s8.12 5.5 8.73 12.66c0 0-4.58-10-9.52-11.45l-2.88 5.02s8.87 5.4 9.88 13.52c0 0-5.15-10.31-10.41-12.38l-2.08 5.33s8.55 5.44 9.34 12.2c0 0-7.16-11.31-9.73-11 0 0-1.61 5-1.4 6.55 0 0 6.05 4 6.16 8 0 0-5.58-7.05-6.44-6.58 0 0-.36 7.08 1.36 10.76 0 0-2.94-5.25-2.47-10.76a11.84 11.84 0 0 0-3.58 5.76s-1.61-3.9 3.69-7.48c0 0 .5-5.51 1.11-6.19 0 0-5.73 2.79-8.16 6.23 0 0 .89-5.12 8.66-7.66l2-5.4s-7.76 3.29-10.15 6.19c0 0 1.72-5.08 10.76-7.51l2.68-5s-6.9 2.32-10.26 5c0 0 2.61-4.37 11.09-6.37l2.18-3.11s-5 1.79-6.4 2.43-1.68.32-1.68.32a18 18 0 0 1 9-4.07s4.85-6.1 4.54-6.41zM921.06 718.6s-37.3 19.27-18 42c0 0 1.81 5 7.06 4.58 0 0-1-1.91 3-3.44a19.35 19.35 0 0 0 4-2.14 9.45 9.45 0 0 0 3.61-4.82s7.63-10.21 1.71-29.09c0 0 .77-5.34.1-6.2l-4.6 6.18s4.68 3.15 5.22 7.76c0 0-4.88-7.75-5.94-6.87-.21.18-2.25 3.4-2.25 3.4s8.12 5.51 8.73 12.66c0 0-4.58-10-9.52-11.44l-2.79 5s8.87 5.4 9.87 13.52c0 0-5.15-10.3-10.4-12.37l-2.08 5.33s8.55 5.43 9.34 12.19c0 0-7.16-11.3-9.73-10.94 0 0-1.61 5-1.4 6.54 0 0 6 4.05 6.16 8 0 0-5.58-7.05-6.44-6.59 0 0-.36 7.09 1.36 10.77 0 0-2.94-5.26-2.47-10.77a11.82 11.82 0 0 0-3.58 5.76s-1.61-3.9 3.69-7.47c0 0 .5-5.51 1.1-6.19 0 0-5.72 2.79-8.15 6.22 0 0 .89-5.11 8.65-7.65l2-5.4s-7.76 3.29-10.16 6.19c0 0 1.72-5.08 10.77-7.52l2.68-5s-6.9 2.33-10.26 5c0 0 2.61-4.36 11.09-6.36l2.18-3.12s-5 1.79-6.41 2.44-1.68.32-1.68.32a18 18 0 0 1 9-4.08s4.88-6.07 4.54-6.4z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1195.94 837.07h1",
    fill: "none"
  }));
};

UndrawBirthdayCake.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawBirthdayCake;